export default "__VITE_ASSET__CmJ1wO9i__"